import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import Logout from './Logout';
// import reportWebVitals from './reportWebVitals';
import * as process from 'process';

window.global = window;
window.process = process;
window.Buffer = [];
window.logout = function() {
 Logout();
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// reportWebVitals();
